"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var _jsxruntime = require("react/jsx-runtime");
var _styled = /*#__PURE__*/ _interop_require_default(require("@emotion/styled"));
var _core = require("@mantine/core");
var _utils = require("@collinsonx/utils");
var _colourconstantspartner = /*#__PURE__*/ _interop_require_default(require("../../colour-constants-partner"));
var _cardImage = /*#__PURE__*/ _interop_require_default(require("./cardImage"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _tagged_template_literal_loose(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    strings.raw = raw;
    return strings;
}
function _templateObject() {
    var data = _tagged_template_literal_loose([
        "\n  position: relative;\n  ",
        "\n  min-width: 350px;\n  cursor: pointer;\n  overflow: hidden;\n  border: 1px solid ",
        ";\n  background-color: #fff;\n  border-radius: 8px;\n  margin-bottom: auto;\n  &:hover {\n    box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.25);\n    transition: all 0.3s ease-in-out;\n    border: 1px solid ",
        ";\n    & > .card-image {\n      background-size: 105%;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var _StyledCard = (0, _styled.default)(_core.Box)(_templateObject(), function(param) {
    var width = param.width;
    return width ? "width: " + width + ";" : "";
}, _colourconstantspartner.default["grey-border"], _colourconstantspartner.default["text-grey"]);
var StyledCard = (0, _core.createPolymorphicComponent)(_StyledCard);
function Card(param) {
    var _param_status = param.status, status = _param_status === void 0 ? _utils.OutletStatus.Active : _param_status, children = param.children, imageCount = param.imageCount, imageUrl = param.imageUrl, hasImagePadding = param.hasImagePadding, width = param.width, imageAlt = param.imageAlt, dataTestId = param["data-testid"], _param_onClick = param.onClick, onClick = _param_onClick === void 0 ? function() {} : _param_onClick, _param_onMouseEnter = param.onMouseEnter, onMouseEnter = _param_onMouseEnter === void 0 ? function() {} : _param_onMouseEnter, _param_onMouseLeave = param.onMouseLeave, onMouseLeave = _param_onMouseLeave === void 0 ? function() {} : _param_onMouseLeave;
    return /*#__PURE__*/ (0, _jsxruntime.jsxs)(StyledCard, {
        p: 0,
        width: width,
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        "data-testid": dataTestId,
        children: [
            /*#__PURE__*/ (0, _jsxruntime.jsx)(_cardImage.default, {
                src: imageUrl,
                hasPadding: hasImagePadding,
                status: status,
                imageCount: imageCount,
                alt: imageAlt
            }),
            /*#__PURE__*/ (0, _jsxruntime.jsx)(_core.Box, {
                p: 24,
                style: {
                    width: "100%"
                },
                children: children
            })
        ]
    });
}
var _default = Card;
